import { capitalizeFirstLetter } from "./capitalize-first-letter";

/**
 * Transforms a Date into the following format: MMM yy.
 * The transformation use the user's locale (pt-br / es / en).
 * The abbreviation of the month changes with the language.
 * E.g.: Transforme de date 2022-12-02
 * pt-br -> "Dez 22"
 * es    -> "Dic 22"
 * en    -> "Dec 22"
 *
 * @param date The date to be transformed
 * @param locale The location of the display format
 * @returns The formatted date
 */
export function dateToMonthYear(date: Date, locale: string): string {
  let month = date
    .toLocaleDateString(locale, {
      month: "short"
    })
    .replace(/\./g, "")
    .toLowerCase();

  month = capitalizeFirstLetter(month);

  const year = date.toLocaleDateString(locale, {
    year: "2-digit"
  });

  return `${month} ${year}`;
}
